// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lzoeA{display:flex;flex-direction:column;gap:16px;margin-bottom:16px}.C0iQA{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;gap:12px}.mobile .C0iQA{gap:8px}.GWfv_{height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lzoeA`,
	"controls": `C0iQA`,
	"editDivider": `GWfv_`
};
export default ___CSS_LOADER_EXPORT___;
